import { isClientSide } from "@helper/utils";
import { useEffect, useState } from "react";

export default function useElementHeight(elementId: string): number {
  const [height, setHeight] = useState(0);

  useEffect(() => {
    if (!isClientSide) return;

    const element = document.getElementById(elementId);

    if (!element) return;

    const updateHeight = () => {
      setHeight(element.offsetHeight);
    };

    updateHeight();

    const resizeObserver =
      typeof ResizeObserver !== "undefined"
        ? new ResizeObserver(() => {
            updateHeight();
          })
        : null;

    resizeObserver?.observe(element);

    window.addEventListener("resize", updateHeight);

    return () => {
      resizeObserver?.disconnect();
      window.removeEventListener("resize", updateHeight);
    };
  }, [elementId]);

  return height;
}
